// src/components/URLForm.js
import React, { useState } from 'react';
import { TextField, Button, Grid } from '@mui/material';

const URLForm = ({ selectedTemplate }) => {
  const [url, setUrl] = useState('');
  const [resultUrl, setResultUrl] = useState('');
  const [urlError, setUrlError] = useState('');

  const handleGenerateUrl = () => {
    try {
      const urlObj = new URL(url);
      if (selectedTemplate) {
        urlObj.searchParams.set('utm_source', selectedTemplate.campaignSource);
        urlObj.searchParams.set('utm_medium', selectedTemplate.campaignMedium);
        urlObj.searchParams.set('utm_campaign', selectedTemplate.campaignName);
        if (selectedTemplate.campaignId) {
          urlObj.searchParams.set('utm_id', selectedTemplate.campaignId);
        }
        if (selectedTemplate.campaignTerm) {
          urlObj.searchParams.set('utm_term', selectedTemplate.campaignTerm);
        }
        if (selectedTemplate.campaignContent) {
          urlObj.searchParams.set('utm_content', selectedTemplate.campaignContent);
        }
        setResultUrl(urlObj.toString());
      } else {
        setResultUrl(url);
      }
      setUrlError('');
    } catch (e) {
      setUrlError('Invalid URL');
      setResultUrl('');
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(resultUrl);
    alert('URL copied to clipboard');
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label="URL"
          variant="outlined"
          fullWidth
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          error={!!urlError}
          helperText={urlError}
        />
      </Grid>
      <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={handleGenerateUrl} fullWidth>
          Generate URL
        </Button>
      </Grid>
      {resultUrl && (
        <>
          <Grid item xs={12}>
            <TextField
              label="Result URL"
              variant="outlined"
              fullWidth
              value={resultUrl}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="secondary" onClick={handleCopy} fullWidth>
              Copy URL
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default URLForm;